import { ArrowBackIosNew, ArrowForwardIos } from "@mui/icons-material";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import api from "_api";
import { concat } from "lodash";
import { formatCurrency2Digit } from "utils/helpers/format";
import { useCarBrands } from "contexts/CarBrandsContext";
import { getBrandName } from "utils/helpers/brandCar";

const defaultArrowStyle = {
  color: "white", // สีของไอคอนลูกศร
  backgroundColor: "rgba(0, 0, 0, 0.5)", // สีพื้นหลังของไอคอน
  height: "32px", // ความสูงของไอคอน
  width: "32px", // ความกว้างของไอคอน
  position: "absolute",
  zIndex: 10,
  padding: "6px",
  cursor: "pointer",
  "&:hover": {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
  borderRadius: "50%",
};

const settingsMain = {
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: (
    <ArrowForwardIos
      sx={{
        ...defaultArrowStyle,
        right: "5%",
        top: "50%",
      }}
    />
  ),
  prevArrow: (
    <ArrowBackIosNew
      sx={{
        ...defaultArrowStyle,
        left: "5%",
        top: "50%",
      }}
    />
  ),
};

const columns = [
  { key: "updated_at", title: "อัปเดต" },
  { key: "product_code", title: "รหัสสินค้า" },
  { key: "category", title: "หมวดหมู่สินค้า" },
  { key: "defects", title: "ตำหนิ" },
  { key: "stock", title: "จำนวนคงเหลือ" },
  { key: "contact", title: "ช่องทางการติดต่อ" },
];

const ModalProduct = ({ open = false, product = null, closeModal }) => {
  const { carBrands } = useCarBrands();

  let silderRef = useRef(null);
  const [detail, setDetail] = useState(null);
  const [type, setType] = useState("product");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open && product) {
      setLoading(true);
      const { car, Product } = product;
      if (car) {
        setType("car");
        fetchProductData(car?.id, "car");
      } else if (Product) {
        setType("product");
        fetchProductData(Product?.product_id, "product");
      } else {
        closeModal();
        setLoading(false);
      }
    }
  }, [product, open]);

  const fetchProductData = async (id, type) => {
    await api.marketplace
      .getMarketplaceProductById(id, type)
      .then((res) => {
        console.log("res", res);
        if (res.isStatus) {
          setDetail(res.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching product data:", error);
        closeModal();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (!product || !detail) {
    return null;
  }
  if (detail && !loading) {
    const {
      product_name = detail?.product_name || detail?.car_name || "",
      price = detail?.price || detail?.sell_price || detail?.car_price || 0,
      Pictures = detail?.Pictures || detail?.picture_cars || [],
      updated_date,
      product_code = detail?.product_code || detail?.car_code || "",
      category_name = detail?.Category?.name || detail?.car_type || "-",
      blemishes,
      remaining_amount,
      Company,
      marketplace_address = detail?.MarketplaceProducts?.[0]
        ?.marketplace_address ||
        detail?.MarketplaceCars?.[0]?.marketplace_address ||
        "",
    } = detail;
    return (
      <Dialog
        open={open}
        onClose={closeModal}
        fullWidth
        maxWidth="md"
        // key={detail?.product_id || detail?.id}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "25px",
          },
        }}
      >
        <DialogContent
          sx={{
            padding: 2,
            mb: 1,
          }}
        >
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: "relative",
                  height: "556px",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                <Slider
                  {...settingsMain}
                  ref={(slider) => (silderRef = slider)}
                >
                  {Pictures.map((image, index) => (
                    <Box
                      key={index}
                      component={"img"}
                      src={image.pic}
                      alt={product_name + "-" + index}
                      sx={{
                        width: "100%",
                        height: "446px",
                        borderRadius: "25px",
                      }}
                    />
                  ))}
                </Slider>
                <Grid container spacing={2}>
                  {Pictures.slice(0, 3).map((image, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      {index === 2 && Pictures.length > 3 ? (
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                            overflow: "hidden",
                            cursor: "pointer",
                          }}
                          onClick={() => silderRef.slickGoTo(index)}
                        >
                          <Box
                            component={"img"}
                            src={image.pic}
                            alt={product_name + "-" + index}
                            sx={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "rgba(0, 0, 0, 0.5)", // คลุมทึบ
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography
                              sx={{
                                color: "white",
                                fontSize: "24px",
                                fontWeight: "bold",
                              }}
                            >
                              +{Pictures.length - 3}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        <Box
                          component={"img"}
                          src={image.pic}
                          alt={product_name + "-" + index}
                          sx={{
                            width: "100%",
                            height: "100px",
                            borderRadius: "25px",
                            cursor: "pointer",
                          }}
                          onClick={() => silderRef.slickGoTo(index)}
                        />
                      )}
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <Box sx={{ display: "flex", gap: 2, flexDirection: "column" }}>
                  <Typography
                    sx={{
                      fontSize: "32px",
                      fontWeight: "medium",
                      color: "#212529",
                    }}
                    noWrap
                  >
                    {product_name}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "32px",
                      fontWeight: "medium",
                    }}
                  >
                    {price >= 1000000
                      ? `${(price / 1000000).toFixed(
                          price % 1000000 > 0 ? 1 : 0
                        )} ล้านบาท`
                      : `${formatCurrency2Digit(price)} บาท`}
                  </Typography>

                  <Table
                    sx={{
                      "& .MuiTableCell-root": {
                        borderBottom: "none",
                        padding: 1,
                        fontSize: "16px",
                        verticalAlign: "top",
                      },
                      "& .MuiTableCell-head": {
                        whiteSpace: "nowrap",
                      },
                      "& .MuiTableCell-body:first-of-type": {
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableBody>
                      <TableRow>
                        <TableCell>อัปเดต</TableCell>
                        <TableCell>{updated_date}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>รหัสสินค้า</TableCell>
                        <TableCell>{product_code}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>หมวดหมู่สินค้า</TableCell>
                        <TableCell>{category_name}</TableCell>
                      </TableRow>
                      {type == "car" && (
                        <>
                          <TableRow>
                            <TableCell>ยี่ห้อ</TableCell>
                            <TableCell>
                              {getBrandName(detail?.car_brand_id, carBrands)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>รุ่น</TableCell>
                            <TableCell>{detail?.model}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>สี</TableCell>
                            <TableCell>{detail?.color}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>เลขไมล์</TableCell>
                            <TableCell>{detail?.car_mileage}</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>จำนวนที่นั่ง</TableCell>
                            <TableCell>{detail?.seat}</TableCell>
                          </TableRow>
                        </>
                      )}
                      <TableRow>
                        <TableCell>ตำหนิ</TableCell>
                        <TableCell>{blemishes ?? "-"}</TableCell>
                      </TableRow>
                      {type != "car" && (
                        <TableRow>
                          <TableCell>จำนวนคงเหลือ</TableCell>
                          <TableCell>{remaining_amount}</TableCell>
                        </TableRow>
                      )}
                      <TableRow>
                        <TableCell>ช่องทางการติดต่อ</TableCell>
                        <TableCell>
                          <Typography>{Company?.name}</Typography>
                          <Typography>{Company?.phone}</Typography>
                          <Typography>{marketplace_address}</Typography>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      borderRadius: "12px",
                      width: "100%",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "medium",
                        color: "#D32F2F",
                      }}
                    >
                      ระวังมิจฉาชีพหลอกโอนเงิน หรือโอนเงินผิดบัญชี!
                    </Typography>
                    <Button
                      sx={{
                        color: "#00bb9f",
                        border: "1px solid #00bb9f",
                        borderRadius: "12px",
                        fontSize: "16px",
                        "&:hover": {
                          background: "white",
                          color: "#00bb9f",
                        },
                      }}
                      onClick={closeModal}
                    >
                      ปิด
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    );
  }
};

export default ModalProduct;
